<mat-card appearance="outlined" class="pb-5">
    <div class="row justify-content-center">
        <div class="col-12">
            <app-data-table 
                [component]="'Reservation Properties'"
                (searchEvent)="onSearchEvent($event)" 
                (pageEvent)="onPageEvent($event)"
                (sortEvent)="onSortEvent($event)"
                [dataSource]="dataSource" 
                [displayedColumns]="displayedColumns" 
                [tableLength]="tableLength" 
                [pageSize]="pageSize"
                [displayLoadingIndicator]="loading" 
                [getStatusColor]="getPropertyStatusColor"
                [rowClicked]="rowClicked"
                [navigateOnRowClick]="false"
                [showPaginator]="true"
                [disablePageSizeSelector]="true"
                [actionButtonText]="'Select Property'"
                (actionClickedEvent)="onSelectPropertyClick($event)"
            >
            </app-data-table>
        </div>
    </div>
</mat-card>